module.exports = __webpack_public_path__ + "components/flag/static/square/nz-f05bbd7f76c5d749540ff4ab43752e2f.svg";